// extracted by mini-css-extract-plugin
module.exports = {"layout_row":"DefaultLayout_layout_row__1eSnb","shrinked":"DefaultLayout_shrinked__hmXmi"};